export const getNavItemLabelColor = (isActive: boolean): string => {
    const colorString = `var(--navi-color-navigation-blue-${isActive ? 'c1' : 'c2'})`;
    return colorString;
};

export const checkIsActiveRoute = (route: string, pathname: string): boolean => {
    if (route === '/') {
        return route === pathname;
    } else {
        return pathname.startsWith(route);
    }
};
